<template>
  <el-cascader
    v-model="_value"
    class="my-cascader"
    :props="options"
    :style="_style"
    v-bind="$attrs"
    :disabled="disabled"
  />
</template>

<script>
export default {
  name: 'CascaderItem',
  props: {
    value: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Number
    },
    options: {
      type: Object,
      default: function() {
        return {}
      }
    },
    width: {
      type: String,
      default: '280px'
    },
    height: {
      type: String,
      default: '40px'
    },

    styleSheet: {
      type: Object,
      default: function() {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    _style() {
      return Object.assign(
        {},
        {
          width: this.width,
          height: this.height,
          'line-height': this.height
        },
        this.styleSheet
      )
    }
  },
  methods: {
    change(val) {
      this._value = val
    }
  }
}
</script>
<style lang='scss' scoped>
::v-deep.my-cascader.el-cascader {
	height: 32px;
	width: 280px;
	.el-input__inner {
		width: 100%;
		height: 40px;
		line-height: 40px;
		// border: 1px solid #dfe3e5;
		// border: 1px solid #f5f7fa;
		border: 1px solid rgba(0,0,0,0.12);
		border-radius: 20px;
	}
}
// ::v-deep.my-cascader.el-input-group--append {
// 	border: 1px solid #dfe3e5;
// 	border-radius: 20px;
// 	.el-input__inner {
// 		border: none;
// 	}
// 	.el-input-group__append {
// 		border: none;
// 		border-radius: 20px;
// 	}
// }
</style>
